@import '../../common/vars.scss';

.split-offer-selected {
  outline: unset !important;
  padding: 4px 6px;
  border: 1px solid #cfd1d8;
  border-radius: 8px;
  border-top-left-radius: 16px;
  box-shadow: none;

  .new-plan-info {
    margin-top: 36px;

    display: flex;
    flex-direction: column;
    z-index: 99;

    &:last-of-type {
      margin-top: 16px;
    }

    position: relative;
    min-height: 1px;
    padding-left: 6px;
    padding-right: 6px;
  }

  .pp-small-text {
    font-size: 14px;
  }

  .header-text {
    font-size: 18px;
  }

  .splash-column {
    margin-bottom: 16px;
  }

  .monthly-payment-amount {
    font-weight: 500;
    color: $color-upgrade-body-header;
  }
}

.offer-card-amount-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  .offer-card-amount-container-inner {
    display: flex;
  }

  .total-num-payments {
    padding: 4px 8px;
    min-width: 65px;
  }
}

.offer-card-bold {
  font-weight: 500;
}

.header-text {
  font-family: Graphik;
  font-size: 24px;
  font-weight: 500;
  line-height: 26.4px;
  text-align: left;
}

.per-month {
  font-size: 14px;
}

.total-num-payments {
  padding: 4px 8px;
  min-width: 65px;

  color: $color-upgrade-actionable-secondary !important;
  background-color: $color-chip-background !important;
  border-radius: 3px !important;
}

.subheader-txt {
  padding: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
}

.gray-text {
  color: $color-upgrade-body-subheader !important;
}

.pp-normal-text {
  color: $color-upgrade-body-header;
}

.chip {
  color: #1f63d2 !important;
  background-color: #e3f1f7 !important;
  border-radius: 3px !important;
}
